import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { message, Spin, Modal } from 'antd';
import Button from '../../../../components/Button/Button';
import { fetchTocAcceptance, fetchUser } from '../../../Account/AccountActions';
import { logout } from '../../../../components/Login/LoginActions';

import './TermsOfUseModal.scss';

export default ({ accepted }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOverayClick = async () => {
    message.error('You must agree to the terms of use to use our service.');
  };

  const onCancel = async () => {
    setLoading(true);
    try {
      await fetchTocAcceptance(false);
    } finally {
      setTimeout(() => {
        message.error('You will be logged out. You must agree to the terms of use to use our service.');
        dispatch(logout());
        setLoading(false);
      }, 2000);
    }
  };

  const onOk = async () => {
    setLoading(true);
    try {
      await fetchTocAcceptance(true);
      message.success('Thank you for agreeing to the Terms of Use.');
      await dispatch(fetchUser());
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={!accepted}
      width="auto"
      destroyOnClose
      confirmLoading
      closable={false}
      centered
      onCancel={handleOverayClick}
      bodyStyle={{ width: '90vw', maxWidth: '800px' }}
      footer={
        <div className="soc-action">
          <Button type="primary" size="large" disabled={loading} onClick={onCancel}>
            Disagree
          </Button>
          <Button type="primary" size="large" disabled={loading} onClick={onOk}>
            Agree
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div className="toc">
          <h2>TERMS OF USE</h2>
          <div>
            By using this service, you warrant that you have licence to do so and you agree you will not:
            <ul>
              <li>(a) sell, sub-licence or distribute for consideration, this service;</li>
              <li>(b) directly or indirectly allow another person to use your licence to this service;</li>
              <li>(c) use the service to develop a product or service which directly competes with the service;</li>
              <li>
                (d) publish, disseminate, or bulk-copy part or all of the service without our express permission;{' '}
              </li>
              <li>
                (e) copy, duplicate, assimilate, or emulate the underlying formula, source code, data, or technologies
                in the services;
              </li>
              <li>(f) reverse engineer, disassemble, or decompile any of the service; or</li>
              <li>(g) otherwise access or use this service other than for its intended purpose. </li>
            </ul>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};
